export default __webpack_public_path__ + "static/media/backgroundvideo.9cbbeef3.mp4";